import React,{useRef,useEffect,useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import LinearProgress from '@mui/material/LinearProgress';
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import axios from 'axios'
import DeleteIcon from '@mui/icons-material/Delete';
import SellIcon from '@mui/icons-material/Sell';

import ProductCategories from '../products/ProductCategories';

const drawerWidth = 300;



const materialTheme = createTheme(({
    // set default for now
  }));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
  fullWidth: {
    width: "100%"
  },
  hoverableListItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5', // Change the background color as desired
    },
  },
}));




const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Principals = (props) => {
    const classes = useStyles();
    const [principalCompanyId, setPrincipalCompanyId] = useState(null);
    const [principals, setPrincipals] = useState([]);
    const [selectedPrincipal, setSelectedPrincipal] = useState(null)
    const [showProductCategoryDialog, setShowProductCategoryDialog] = useState(false)

    useState(()=> {
       console.log( props.principals)
    })

    
    const principalBody = () => {
        return (
            <>
            {props.principals.map((principal, key) => (
               <div>
                <React.Fragment key={key + principal.seller_company_id} >
                    <ListItem  
                        key={key + principal.seller_company_id} 
                        divider 
                        style={{ boxShadow: 'none', cursor: 'pointer' }}
                        className={classes.hoverableListItem}
                        onClick={() => {
                            setSelectedPrincipal(principal)
                            // setShowProductCategoryDialog(true)

                            
                            const newProduct = { ...props.product, principal: principal.name };
                            
                            props.setProducts(newProduct)
                            props.setShowPrincipalDialog(false)
                        }}
                        >
                       {principalElement(principal)}
                    </ListItem>
                </React.Fragment>
               </div>
            ))}
            </>
        )
    }

    const principalElement = (principal) => {
        return(<div>
          <Typography variant="h6" gutterBottom>
              {principal.name}
          </Typography>
          <Typography variant="body1" gutterBottom>
              {principal.seller_company_id}
          </Typography>
        </div>)
    }
        
    return (
        <div>
            
           <Dialog 
            fullScreen 
            open={props.showPrincipalDialog} 
            onClose={()=>{props.setProductAction("add")}} 
            TransitionComponent={Transition}
            >
            <AppBar className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={()=>{
                            
                            props.setShowPrincipalDialog(false)
                            
                        }
                            
                            
                        }
                        aria-label="close"
                        size="large">
                    <CloseIcon />
                    </IconButton>
                    <Typography variant="subtitle1" className={classes.title}>
                       {"PRINCIPALS"}
                    </Typography>
                </Toolbar>
            </AppBar>
            <div className={classes.appBarSpacer}></div>
            <List>
                {principalBody()}
            </List>
      </Dialog>
      
      {
        showProductCategoryDialog 
        ? 
        <ProductCategories 
            selectedPrincipal = {selectedPrincipal}
            setShowProductCategoryDialog = {setShowProductCategoryDialog}
            setShowPrincipalDialog = {props.setShowPrincipalDialog}
            setProducts = {props.setProducts}
            product = {props.product}
        /> 
        : 
        ""
        }

      <StyledEngineProvider injectFirst>
          <ThemeProvider theme={materialTheme}>
            
            </ThemeProvider>
      </StyledEngineProvider>
        </div>
    );
}

export default Principals;